// api/FetchEventData.js
import EventsStructure from "../Constants/EventsStructure.js";

export const FetchEventData = async (month) => {
  try {
    const response = await fetch(`/api/mock/${month}Event/${month}EventMockData.json`); // mock file path
    if (!response.ok) {
      throw new Error(`Failed to fetch events: ${response.statusText}`);
    }

    const data = await response.json();

    const formattedData = {
      ...EventsStructure,
      eventfeedId: data.eventfeedId || "",
      timeperiod: data.timeperiod || "",
      eventfeedUUID: data.eventfeedUUID || "",
      events: (data.events || []).map((event) => ({
        eventid: event.eventid || "",
        eventuuid: event.eventuuid || "",
        eventname: event.eventname || "",
        event_type: event.event_type || "",
        event_timestamp: event.event_timestamp || "",
        createdby: event.createdby || "",
        nmembers: event.nmembers || 0,
        eventimageurl: event.eventimageurl || "",
        description: event.description || "",
      })),
    };

    return formattedData;
  } catch (error) {
    console.error("Failed to fetch event data:", error);
    return EventsStructure; // fallback empty structure
  }
};
